import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const normalizeInitialPath = () => {
  if (typeof window === "undefined") return;
  const { pathname, search, hash } = window.location;
  let normalizedPath = String(pathname || "/");
  normalizedPath = normalizedPath.replace(/\/{2,}/g, "/");
  normalizedPath = normalizedPath.replace(/\/index\.html\/?$/i, "");
  if (!normalizedPath.startsWith("/")) {
    normalizedPath = `/${normalizedPath}`;
  }
  if (normalizedPath.length > 1) {
    normalizedPath = normalizedPath.replace(/\/+$/, "");
  }
  normalizedPath = normalizedPath || "/";
  const nextUrl = `${normalizedPath}${search || ""}${hash || ""}`;
  const currentUrl = `${pathname}${search || ""}${hash || ""}`;
  if (nextUrl !== currentUrl) {
    window.history.replaceState(window.history.state, document.title, nextUrl);
  }
};

normalizeInitialPath();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
